'use strict';

var base = require('core/product/base');
var focusHelper = require('core/components/focus');
var attributesLogic = require('../product/attributes');
var toastUtil = require('../utils/toastPopup');
const reviews = require('../product/reviews');

const notifUtils = require('../utils/notificationUtils');
var pushToDataLayer = require('../global/gtm').pushToDataLayer;

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (data.valid.error) {
        if (data.valid.message) {
            var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error '
                + 'fade show" role="alert">'
                + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
                + '<span aria-hidden="true">&times;</span>'
                + '</button>' + data.valid.message + '</div>';

            $('.cart-error').append(errorHtml);
        } else {
            $('.cart').empty().append('<div class="row"> '
                + '<div class="col-12 text-center"> '
                + '<h1>' + data.resources.emptyCartMsg + '</h1> '
                + '</div> '
                + '</div>');
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-quantity').empty().append(data.numItems);
            $('.cart-total-quantity').empty().append(data.numItems);
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems
            });
            $('.minicart .popover').empty().removeClass('show');
        }

        $('.checkout-btn').addClass('disabled');
    } else {
        $('.checkout-btn').removeClass('disabled');
    }
}

/**
 * Builds the markup of a promotion row displayed in the cart totals
 * @param {Object} promotion - promotion to render (label, value, type, appliedTo)
 * @param {string} containerClass - class applied to the row container
 * @returns {string} the promotion row markup
 */
function renderPromotionRow(promotion, containerClass) {
    // shipping promotions already carry their sign in the value
    let isShippingPromotion = promotion.type === 'promotion' && promotion.appliedTo === 'shipping';
    let sign = isShippingPromotion ? '' : '-';

    return `<div class="d-flex justify-content-between ${containerClass}">`
        + `<dt>${promotion.promotionLabel}</dt>`
        + `<dd class="mb-0">${sign}${promotion.value.toFixed(2)}€</dd>`
        + '</div>';
}

/**
 * re-renders the promotion rows of every cart totals block (mobile and desktop)
 * @param {string} containersSelector - selector of the promotion containers to update
 * @param {Array<Object>} promotions - promotions to display
 * @param {string} rowClass - class applied to each promotion row
 */
function updatePromotionRows(containersSelector, promotions, rowClass) {
    let html = (promotions || []).map(function (promotion) {
        return renderPromotionRow(promotion, rowClass);
    }).join('');

    // the totals block is rendered twice (mobile and desktop), both must be updated
    $(containersSelector).html(html);
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('.number-of-items').empty().append(data.resources.numberOfItems);
    $('.shipping-cost').empty().append(data.totals.shippingMessage);
    $('.tax-total').empty().append(data.totals.totalTax);
    const $remiseclubDisplay = $('.remiseclubDisplay');
    if (data.clubPrice) {
        $remiseclubDisplay.text(data.clubPrice.formatted);
        $remiseclubDisplay.attr('data-value', data.clubPrice.value);
        $('.club-advantage-total').empty().append('- ' + data.clubPrice.formatted);
        $('.club-advantage-value').empty().append(data.clubPrice.formatted);
    } else {
        $remiseclubDisplay.text('');
        $remiseclubDisplay.attr('data-value', 0);
    }
    $('.grand-total').empty().append(data.totals.grandTotal);
    $('.sub-total').empty().append(data.totals.subTotal);
    $('.minicart-quantity').empty().append(data.numItems);
    $('.cart-total-quantity').empty().append(data.numItems);
    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems
    });
    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').empty().append('- '
            + data.totals.shippingLevelDiscountTotal.formatted);
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }

    if (data.totalCartAmounts) {
        const currency = data.totalCartAmounts.currency;

        $('#totalStandard .total-standard-value').text(`${data.totalCartAmounts.totalStandard}${currency}`);

        if (data.totalCartAmounts.totalClubDiscount > 0) {
            $('#totalClubDiscount .total-club-value').text(`-${data.totalCartAmounts.totalClubDiscount}${currency}`);
            $('.js-total-club-discount .total-club-value').text(`-${data.totalCartAmounts.totalClubDiscount}€`);
        } else {
            $('.js-total-club-discount').empty();
        }

        if (data.totalCartAmounts.totalSalesDiscount > 0) {
            $('#totalSalesDiscount .total-sale-value').text(`-${data.totalCartAmounts.totalSalesDiscount}${currency}`);
        } else {
            $('#totalSalesDiscount').empty();
        }

        let productPromotions = $('#productPromotions');
        if (data.totalCartAmounts.productPromotions.length) {
            // reset the html content of productPromotions
            productPromotions.empty();
            data.totalCartAmounts.productPromotions.forEach(function (productPromotion, i) {
                // create new html elements with updated information
                productPromotions.append(`<div class="d-flex justify-content-between product-promotion-container-${i}"></div>`);

                let productPromotionContainer = $(`.product-promotion-container-${i}`);
                productPromotionContainer.append(`<dt>${productPromotion.promotionLabel}</dt>`);
                productPromotionContainer.append(`<dd class="mb-0">-${productPromotion.value.toFixed(2)}${currency}</dd>`);
            });
            $('.js-total-sales-discount .total-sale-value').text(`-${data.totalCartAmounts.totalSalesDiscount}€`);
        } else {
            $('.js-total-sales-discount').empty();
        }

        $('#basketTotalAmount .basket-total-value').text(`${data.totalCartAmounts.totalToPay}${currency}`);
        updatePromotionRows('.js-product-promotions', data.totalCartAmounts.productPromotions, 'product-promotion-container');
        updatePromotionRows('.js-basket-promotions', data.totalCartAmounts.basketPromotions, 'basket-promotion-container');
        $('#basketTotalAmount .basket-total-value').text(`${data.totalCartAmounts.totalToPay}`);
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error '
        + 'fade show" role="alert">'
        + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
        + '<span aria-hidden="true">&times;</span>'
        + '</button>' + message + '</div>';

    $('.cart-error').append(errorHtml);
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = '';
    $('.approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            html += '<div class="single-approaching-discount text-center">'
                + item.discountMsg + '</div>';
        });
    }
    $('.approaching-discounts').append(html);
}

/**
 * re-renders the coupon error messages
 * @param {Object} data - cart data
 */
function updateCouponErrorMsg(data) {
    if (data.totals && data.totals.discounts) {
        var coupons = data.totals.discounts;
        if (coupons.length > 0) {
            var couponNotAppliedMsg = '';
            for (var i = 0; i < coupons.length; i++) {
                if (coupons[i].applied === false) {
                    couponNotAppliedMsg += coupons[i].couponCode + ' ' + data.resources.couponError + ' <br/>';
                }
            }
            $('.coupon-error-message').empty().append(couponNotAppliedMsg);
        }
    }
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    if (lineItem != null) {
        $('.availability-' + lineItem.UUID).empty();

        if (lineItem.availability) {
            if (lineItem.availability.messages) {
                lineItem.availability.messages.forEach(function (message) {
                    messages += '<p class="line-item-attributes">' + message + '</p>';
                });
            }

            if (lineItem.availability.inStockDate) {
                messages += '<p class="line-item-attributes line-item-instock-date">'
                    + lineItem.availability.inStockDate
                    + '</p>';
            }
        }

        $('.availability-' + lineItem.UUID).html(messages);
    }
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    $('.card.product-info.uuid-' + uuid).replaceWith(data.renderedTemplate);
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);
            var editProductModal = $('#editProductModal');
            editProductModal.find('.modal-body').empty();
            editProductModal.find('.modal-body').html(parsedHtml.body);

            editProductModal.find('.modal-footer').html(parsedHtml.footer);
            editProductModal.find('.modal-header .close .sr-only').text(data.closeButtonText);
            editProductModal.find('.enter-message').text(data.enterDialogMessage);
            editProductModal.modal('show');
            $('body').trigger('editproductmodal:ready');
            editProductModal.find('.product-attributes-section div[data-attr="orc_size"] .circle-attribute')
                .removeClass('circle-unselected').addClass('circle-selected').text(data.product.variationAttributes[1].displayValue);
            editProductModal.find('.attribute-values-section div[data-attr="orc_size"] .circle-attribute').each(function () {
                var $this = $(this);
                var $selectedSize = $this.find('.attribute-value').text();
                if ($selectedSize === data.product.variationAttributes[1].displayValue) {
                    $this.removeClass('circle-unselected').addClass('circle-selected');
                }
            });
            editProductModal.find('.availability').empty();
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Display the "Product added to the cart" message
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    // show add to cart toast
    if ($('.quick-view-add-to-cart-messages').length === 0) {
        if ($('.cart-page').length !== 0) {
            $('.cart-page').append('<div class="quick-view-add-to-cart-messages"></div>');
        }
    }
    if ($('.quick-view-add-to-basket-alert').length === 0) {
        $('.quick-view-add-to-cart-messages').append(
            '<div class="quick-view-add-to-basket-alert text-center" role="alert">'
            + response.message
            + '</div>'
        );
    }

    setTimeout(function () {
        $('.quick-view-add-to-cart-messages').remove();
    }, 5000);
}

/**
 * updates alma progress bar
 * @param {string} cartTotal cart total amount
 */
function updateAlmaGauge(cartTotal) {
    const parsedTotal = typeof cartTotal === 'string' ? parseFloat(cartTotal.replace(',', '.').replace(/[^\d.]/g, '')) : cartTotal;
    if (Number.isNaN(parsedTotal)) return;
    document.querySelectorAll('.alma-gauge').forEach(function (gaugeEl) {
        const minAmount = parseFloat(gaugeEl.dataset.minAmount);
        const progressBar = gaugeEl.querySelector('orch-progress-bar');
        if (progressBar) {
            progressBar.setAttribute('current', parsedTotal);
            progressBar.setAttribute('reached', parsedTotal >= minAmount ? '' : null);
        }
        const ratio = gaugeEl.querySelector('.alma-ratio');
        if (ratio) {
            const formatAmount = function (val) {
                if (typeof val === 'string') {
                    val = parseFloat(val);
                }
                return val % 1 === 0 ? Math.round(val) : val.toFixed(2);
            };
            ratio.innerHTML = parsedTotal >= minAmount
                ? '<strong>' + gaugeEl.dataset.progressCompletedText + '</strong>'
                : '<strong>' + formatAmount(parsedTotal) + '</strong>/' + formatAmount(minAmount) + '€';
        }
    });
}

/**
 * updates free shipping progress bar
 * @param {string} cartTotal cart total amount
 */
function updateShippingGauge(cartTotal) {
    const parsedTotal = typeof cartTotal === 'string' ? parseFloat(cartTotal.replace(',', '.').replace(/[^\d.]/g, '')) : cartTotal;
    if (Number.isNaN(parsedTotal)) return;
    document.querySelectorAll('.shipping-gauge').forEach(function (gaugeEl) {
        const threshold = parseFloat(gaugeEl.dataset.threshold);
        const reached = parsedTotal >= threshold;
        const progressBar = gaugeEl.querySelector('orch-progress-bar');
        if (progressBar) {
            progressBar.setAttribute('current', parsedTotal);
            progressBar.setAttribute('background-color', reached ? 'success-light' : 'neutral-100');
            if (reached) {
                progressBar.setAttribute('reached', '');
            } else {
                progressBar.removeAttribute('reached');
            }
        }
        if (reached) {
            gaugeEl.classList.remove('o-bg-neutral-200');
            gaugeEl.classList.add('o-bg-success-light');
        } else {
            gaugeEl.classList.remove('o-bg-success-light');
            gaugeEl.classList.add('o-bg-neutral-200');
        }
        const iconReached = gaugeEl.querySelector('.shipping-gauge-icon--reached');
        const iconProgress = gaugeEl.querySelector('.shipping-gauge-icon--progress');
        if (iconReached) iconReached.classList.toggle('o-d-none', !reached);
        if (iconProgress) iconProgress.classList.toggle('o-d-none', reached);
        const msg = gaugeEl.querySelector('.shipping-gauge-message');
        if (msg) {
            const formatAmount = function (val) {
                return val % 1 === 0 ? Math.round(val) : val.toFixed(2);
            };
            const remaining = Math.max(0, threshold - parsedTotal);
            const decode = function (str) {
                return str.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/''/g, "'");
            };
            msg.innerHTML = reached
                ? decode(gaugeEl.dataset.reachedText)
                : decode(gaugeEl.dataset.progressText)
                    .replace('{0}', formatAmount(remaining));
        }
    });
}

/**
 * Handle product exchange action
 * @param {Object} detail - data from the selected product
 * @param {string} replacementPid - id of replace product
 * @param {Object} card - cartProductCard object
 */
function handleProductExchange(detail, replacementPid, card) {
    $.spinner().start();
    $.ajax({
        url: card.lineItem.actionUrls.replaceProductUrl,
        type: 'post',
        dataType: 'json',
        data: {
            oldUUID: detail.uuid,
            newPid: replacementPid
        },
        success: function (data) {
            if (!data.success) {
                createErrorNotification(data.errorMessage || 'Error');
                $.spinner().stop();
                return;
            }
            document.getElementById('exchange-modal').isOpen = false;

            const successAlert = document.getElementById('exchange-success-alert');
            successAlert.classList.remove('o-d-none');
            successAlert.isOpen = true;

            // Mise à jour dynamique des cartes
            if (data.cartProductCardJSON) {
                const cardVMs = JSON.parse(data.cartProductCardJSON);
                const domUuids = Array.prototype.map.call(
                    document.querySelectorAll('orch-cart-product-card'),
                    function (el) { return el.getAttribute('data-uuid'); }
                );
                // La nouvelle ligne est celle dont l'UUID n'est pas encore dans le DOM.
                const newCard = cardVMs.filter(function (pc) {
                    return domUuids.indexOf(pc.lineItem.UUID) === -1;
                })[0];

                const oldEl = document.querySelector('orch-cart-product-card[data-uuid="' + detail.uuid + '"]');

                if (newCard && oldEl) {
                    oldEl.setAttribute('data-uuid', newCard.lineItem.UUID);
                    oldEl.setAttribute('cartproductcard', JSON.stringify(newCard));
                    oldEl.cartProductCard = newCard;
                } else if (!newCard && oldEl) {
                    oldEl.remove();
                }

                cardVMs.forEach(function (pc) {
                    if (newCard && pc.lineItem.UUID === newCard.lineItem.UUID) return;
                    const el = document.querySelector('orch-cart-product-card[data-uuid="' + pc.lineItem.UUID + '"]');
                    if (el) {
                        el.setAttribute('cartproductcard', JSON.stringify(pc));
                        el.cartProductCard = pc;
                    }
                });

                // Garder #cart-container[data-cart] synchronisé (source d'hydratation).
                const container = document.getElementById('cart-container');
                if (container) container.setAttribute('data-cart', JSON.stringify(cardVMs));
            }

            updateCartTotals(data);
            validateBasket(data);
            updateAlmaGauge(data.totalCartAmounts.totalToPay);
            updateShippingGauge(data.totalCartAmounts.totalToPay);
            $.spinner().stop();
        },
        error: function (err) {
            createErrorNotification(err.responseJSON.errorMessage || 'Error');
            $.spinner().stop();
        }
    });
}

/**
 * Display the "Add Club Card product to cart" button
 * @param {string} cart - cart element
 */
function handleClubCardUpdate(cart) {
    // if the cart has a club card
    if (cart.hasClubCardProduct) {
        $('.club-card-cta').removeClass('d-md-block');
        $('.club-card-cta-sticky').removeClass('d-block');
    } else {
        $('.club-card-cta').addClass('d-md-block');
        $('.club-card-cta-sticky').addClass('d-block');
    }
    stickyClubCardCTA();
}

/**
 * Function to adjust the position of a sticky element above another sticky element.
 * @param {jQuery} $aboveSticky - The jQuery element to be positioned above the target element.
 * @param {jQuery} $targetSticky - The jQuery element to use as a reference for positioning.
 */
function stickyClubCardCTA() {
    const $clubCardCtaSticky = $('.club-card-cta-sticky');
    const $checkoutContinue = $('.checkout-continue');

    /**
    * Adjusts the sticky position of the club card CTA
    */
    function adjustStickyPosition() {
        const checkoutContinueHeight = $checkoutContinue.height();
        $clubCardCtaSticky.css('bottom', checkoutContinueHeight - 15 + 'px');
    }

    adjustStickyPosition();

    $(window).on('resize', adjustStickyPosition);
}

/**
 * Function to display a coupon alert by temporarily removing and then restoring a CSS class.
 */
function displayCouponAlert() {
    const couponAlert = $('.coupon-alert');
    const clubCardCta = $('.club-card-cta');
    const couponAlertSticky = $('.coupon-alert-sticky');
    const clubCardCtaSticky = $('.club-card-cta-sticky');
    const continueCheckout = $('.checkout-continue');

    couponAlert.removeClass('d-md-none');

    if (clubCardCtaSticky.hasClass('d-block')) {
        const totalHeight = continueCheckout.height() + (clubCardCtaSticky.height() - 45);
        couponAlertSticky.css('bottom', totalHeight + 'px');
    } else {
        const continueCheckoutHeight = continueCheckout.height() - 20;
        couponAlertSticky.css('bottom', continueCheckoutHeight + 'px');
    }

    if (clubCardCta.hasClass('d-md-block')) {
        const totalHeight = continueCheckout.height() + (clubCardCta.height() - 10);
        couponAlert.css('top', totalHeight + 'px');
    } else {
        const continueCheckoutHeight = continueCheckout.height() + 15;
        couponAlert.css('top', continueCheckoutHeight + 'px');
    }

    couponAlertSticky.removeClass('d-none');

    setTimeout(function () {
        couponAlert.addClass('d-md-none');
        couponAlertSticky.addClass('d-none');
    }, 5000);
}

/**
 * Get the height of the element with the class 'checkout-continue' and set it as the margin-bottom of the element with the ID 'maincontent'.
 * This function assumes that jQuery is used to select and manipulate the elements.
 *
 * @function
 * @name getSetHeight
 * @returns {void}
 */
function getSetHeight() {
    if (window.innerWidth <= 543 && $('.checkout-continue').length > 0) {
        var stickyHeight = $('.checkout-continue').height();

        $('#maincontent').css('margin-bottom', stickyHeight + 'px');
    }
}

/**
 * Displays the savings amount if a club sales pricing element is present on the page.
 *
 * Checks for the presence of an element with the class `.club-sales-pricing`.
 * If found, it removes the `d-none` class from the `.save-amount` element to make it visible.
 */
function setClubCardSavings() {
    const hasClubPrice = parseFloat($('#remiseclubDisplay').attr('data-value')) !== 0;

    $('.save-amount').toggleClass('d-none', !hasClubPrice);
    $('.subscribe-to-club').toggleClass('d-none', hasClubPrice);
}

/**
 * add data to product card on page load
 */
function hydrateProductCards() {
    const cartData = $('#cart-container').data('cart');
    if (!cartData) return;
    const parsedCartData = typeof cartData === 'string' ? JSON.parse(cartData) : cartData;
    if (window.customElements) {
        customElements.whenDefined('orch-cart-product-card').then(function () {
            document.querySelectorAll('orch-cart-product-card').forEach(function (el) {
                const uuid = el.getAttribute('data-uuid');
                const item = parsedCartData.find(function (i) { return i.lineItem.UUID === uuid; });

                if (item) {
                    el.cartProductCard = item;
                }
            });
        });
    }
}

/**
 * add modal content with data on page load
 */
function hydrateExchangeModal() {
    const modal = document.getElementById('exchange-modal');
    if (!modal) return;
    const cartData = $('#cart-container').data('cart');
    if (!cartData || !window.customElements) return;
    const parsedCartData = typeof cartData === 'string' ? JSON.parse(cartData) : cartData;

    const carouselLabels = parsedCartData[0] && parsedCartData[0].carouselLabels
        ? JSON.stringify(parsedCartData[0].carouselLabels)
        : '{}';

    modal.modalContent = [
        '<div class="o-mt-static-3"><orch-product-to-replace-summary id="exchange-summary" class="o-mt-static-4"></orch-product-to-replace-summary></div>',
        '<h3 class="o-my-static-5">' + ($('.cart-page').data('exchange-title') || 'Remplacer par') + '</h3>',
        '<orch-carousel id="exchange-carousel" slides-per-view="2" show-dots="true" gap="24px" labels=\'' + carouselLabels + '\'></orch-carousel>'
    ].join('');
}

/**
 * Affiche l'alerte danger au chargement si une ligne du panier est indisponible.
 * L'attribut isOpen rendu en ISML est ignoré (casse camelCase non observée par l'Angular Element),
 * on ouvre donc l'alerte via la propriété et on retire o-d-none.
 */
function initUnavailableAlert() {
    const cartData = $('#cart-container').data('cart');
    if (!cartData || !window.customElements) return;
    const parsedCartData = typeof cartData === 'string' ? JSON.parse(cartData) : cartData;
    const hasUnavailable = parsedCartData.some(function (c) {
        return c.lineItem && !c.lineItem.available;
    });
    if (!hasUnavailable) return;

    customElements.whenDefined('orch-alert').then(function () {
        const alertEl = document.getElementById('exchange-alert');
        if (alertEl) {
            alertEl.classList.remove('o-d-none');
            alertEl.isOpen = true;
        }
    });
}

/**
 * Get cartProductCard from html element
 * @param { Element } element The html element (a cartProductCard)
 * @returns { Object | null } cartProductCard or null
 */
function getCartProductCard(element) {
    const rawCardAttribute = element.attributes.cartproductcard;

    if (!rawCardAttribute) {
        return null;
    }

    try {
        return JSON.parse(rawCardAttribute.value);
    } catch (error) {
        console.error('Error in getCartProductCard parsing data : ', error);
        return null;
    }
}

/**
 * Error handler for ajax calls
 * @param { Object } error Error object
 */
function ajaxErrorHandler(error) {
    if (error.responseJSON && error.responseJSON.redirectUrl) {
        window.location.href = error.responseJSON.redirectUrl;
    } else {
        createErrorNotification(error.responseJSON ? error.responseJSON.errorMessage : 'Error');
        $.spinner().stop();
    }
}

/**
 * handles the case cart is empty
 * @param {Object} data data from ajax response
 */
function handleEmptyCart(data) {
    $('.cart').empty().append('<div class="container cart-empty">'
        + '<div class="row">'
        + '    <div class="col-12 d-flex align-items-center flex-column">'
        + '        <i class="icon icon-pictoToteBag"></i>'
        + '        <span class=" text-muted">' + data.basket.resources.emptyCartMsg + '</span>'
        + '    </div>'
        + '</div>'
        + '</div>');
    $('.number-of-items').empty().append(data.basket.resources.numberOfItems);
    $('.minicart-quantity').empty().append(data.basket.numItems);
    $('.minicart-link').attr({
        'aria-label': data.basket.resources.minicartCountOfItems,
        title: data.basket.resources.minicartCountOfItems
    });
    $('.minicart .popover').empty().removeClass('show');
    $('body').removeClass('modal-open');
    $('html').removeClass('veiled');
    $('.totals').addClass('emptycart-totals');
}

/**
 * Handles quantityChange event
 * @param { Element } element The html element (a cartProductCard)
 */
function quantityChangeHandler(element) {
    element.addEventListener('quantityChange', function (event) {
        const detail = event.detail;
        const card = getCartProductCard(element);
        if (!card || !card.lineItem) return;

        let url = card.lineItem.actionUrls.updateQuantityUrl;
        const urlParams = {
            pid: detail.pid,
            quantity: detail.quantity,
            uuid: detail.uuid,
            pagetype: window.GTMConstants ? window.GTMConstants.ECOMM_PAGE_TYPE_CART : 'cart'
        };
        url = appendToUrl(url, urlParams);
        $('body').trigger('cart:beforeUpdate');
        $.spinner().start();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                updateCouponErrorMsg(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                updateCartTotals(data);
                setClubCardSavings();
                updateAvailability(data, detail.uuid);
                validateBasket(data);
                updateAlmaGauge(data.totalCartAmounts.totalToPay);
                updateShippingGauge(data.totalCartAmounts.totalToPay);

                if (data.cartProductCardJSON) {
                    const productCard = JSON.parse(data.cartProductCardJSON);
                    productCard.forEach(function (pc) {
                        const cardEl = document.querySelector(
                            'orch-cart-product-card[data-uuid="' + pc.lineItem.UUID + '"]'
                        );
                        if (cardEl) cardEl.cartProductCard = pc;
                    });
                }

                const pageBody = $('body');
                pageBody.trigger('cart:update', data);
                pageBody.trigger('cart:afterUpdateQuantity', {
                    response: data,
                    totalProductsBeforeUpdate: document.querySelectorAll('orch-cart-product-card').length
                });
                $.spinner().stop();
            },
            error: function (err) {
                ajaxErrorHandler(err);
            }
        });
    });
}

/**
 * Handles the DOM updates after a successful product removal from cart
 * @param {Object} data - AJAX response from the server
 * @param {Object} detail - Event detail containing uuid and pid of the removed item
 */
function handleRemoveItemSuccess(data, detail) {
    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
        data.toBeDeletedUUIDs.forEach(function (uuid) {
            const del = document.querySelector('orch-cart-product-card[data-uuid="' + uuid + '"]');
            if (del) del.remove();
        });
    }

    const cardEl = document.querySelector('orch-cart-product-card[data-uuid="' + detail.uuid + '"]');
    if (cardEl) cardEl.remove();

    if (!data.basket.hasBonusProduct) {
        $('.bonus-product').remove();
    }
    handleClubCardUpdate(data.basket);
    $('.coupons-and-promos').empty().append(data.basket.totals.discountsHtml);
    updateCouponErrorMsg(data);
    if (data.totalCartAmounts) {
        data.basket.totalCartAmounts = data.totalCartAmounts;
    }
    updateCartTotals(data.basket);
    setClubCardSavings();
    updateApproachingDiscounts(data.basket.approachingDiscounts);
    $('body').trigger('setShippingMethodSelection', data.basket);
    validateBasket(data.basket);
    updateAlmaGauge(data.totalCartAmounts.totalToPay);
    updateShippingGauge(data.totalCartAmounts.totalToPay);
}

/**
 * Handles removeItem event
 * @param { Element } element The html element (a cartProductCard)
 */
function removeItemHandler(element) {
    element.addEventListener('removeItem', function (event) {
        const detail = event.detail;
        const card = getCartProductCard(element);
        if (!card || !card.lineItem) return;

        let url = card.lineItem.actionUrls.removeProductLineItemUrl;
        const urlParams = {
            pid: detail.pid,
            uuid: detail.uuid
        };
        url = appendToUrl(url, urlParams);
        $('.modal-backdrop').remove();
        $.spinner().start();
        $('body').trigger('cart:beforeUpdate');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.basket.items.length === 0) {
                    handleEmptyCart(data);
                } else {
                    handleRemoveItemSuccess(data, detail);
                }
                $('body').trigger('cart:update', data);
                $.spinner().stop();
            },
            error: function (err) {
                ajaxErrorHandler(err);
            }
        });
    });
}

/**
 * Handles moveToWishlist event
 * @param { Element } element The html element (a cartProductCard)
 */
function moveToWishlistHandler(element) {
    element.addEventListener('moveToWishlist', function (event) {
        const detail = event.detail;
        const card = getCartProductCard(element);
        if (!card || !card.lineItem) return;

        const addUrl = card.lineItem.actionUrls.addProductUrl;
        const removeUrl = card.lineItem.actionUrls.removeProductLineItemUrl;

        const pid = detail.pid;
        const uuid = detail.uuid;
        if (!addUrl || !pid) return;
        $.spinner().start();
        $.ajax({
            url: addUrl,
            type: 'post',
            dataType: 'json',
            data: {
                pid: pid
            },
            success: function () {
                toastUtil.displayToastPopup('.popine-success');
                const removeParams = { pid: pid, uuid: uuid };
                const removeFullUrl = appendToUrl(removeUrl, removeParams);
                $.ajax({
                    url: removeFullUrl,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        if (data.basket.items.length === 0) {
                            handleEmptyCart(data);
                        } else {
                            handleRemoveItemSuccess(data, { uuid: uuid, pid: pid });
                        }
                        $('body').trigger('cart:update', data);
                        $.spinner().stop();
                    },
                    error: function (err) {
                        ajaxErrorHandler(err);
                    }
                });
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
}

/**
 * Handles editProduct event
 * @param { Element } element The html element (a cartProductCard)
 */
function editProductHandler(element) {
    element.addEventListener('editProduct', function () {
        const card = getCartProductCard(element);
        if (!card || !card.lineItem) return;

        const editUrl = card.lineItem.actionUrls.editActionUrl;
        if (editUrl) {
            getModalHtmlElement();
            fillModalElement(editUrl);
        }
    });
}

/**
 * Handles replaceProduct event
 * @param { Element } element The html element (a cartProductCard)
 */
function replaceProductHandler(element) {
    let currentExchange = null;
    let currentSuggestions = [];

    /**
     * Displays a message when no suggestions are available
     */
    function handleNoSuggestions() {
        const noSuggestionsMsg = $('.cart-page').data('no-suggestions-msg') || 'Aucune alternative disponible';
        document.getElementById('exchange-carousel').style.display = 'none';
        let msgEl = document.getElementById('exchange-no-suggestions');
        if (!msgEl) {
            msgEl = document.createElement('p');
            msgEl.id = 'exchange-no-suggestions';
            msgEl.className = 'o-text-center o-text-neutral-700 o-my-static-5';
            document.getElementById('exchange-carousel').insertAdjacentElement('afterend', msgEl);
        }
        msgEl.textContent = noSuggestionsMsg;
        msgEl.style.display = '';
    }

    /**
     * Handles the carousel action event to trigger product exchange
     * @param {Event} e - The action event from the carousel
     */
    function handleCarouselAction(e) {
        const item = e.detail;
        const replacementPid = item && item.productData && item.productData.product
            ? item.productData.product.id
            : null;
        if (replacementPid && currentExchange && currentExchange.card) {
            handleProductExchange(currentExchange.detail, replacementPid, currentExchange.card);
        }
    }

    /**
     * Removes a product from the wishlist and updates the carousel
     * @param {string} pid - Product ID
     * @param {HTMLElement} carousel - The carousel element
     */
    function removeFromWishlist(pid, carousel) {
        const removeUrl = $('.cart-page').data('remove-from-wishlist-url');
        if (!removeUrl) return;
        $.ajax({
            url: removeUrl,
            type: 'get',
            dataType: 'json',
            data: { pid: pid },
            success: function (res) {
                if (!res || res.success === false) {
                    createErrorNotification('Error');
                    return;
                }
                currentSuggestions = currentSuggestions.map(function (currentSuggestion) {
                    if (!(currentSuggestion.productData && currentSuggestion.productData.product && currentSuggestion.productData.product.id === pid)) {
                        return currentSuggestion;
                    }
                    return {
                        ...currentSuggestion,
                        productData: {
                            ...currentSuggestion.productData,
                            wishlist: { ...currentSuggestion.productData.wishlist, isFavorite: false }
                        }
                    };
                });
                carousel.items = currentSuggestions;
            }
        });
    }

    /**
     * Adds a product to the wishlist and removes it from the carousel
     * @param {string} pid - Product ID
     * @param {HTMLElement} carousel - The carousel element
     */
    function addToWishlist(pid, carousel) {
        const addUrl = $('.cart-page').data('add-to-wishlist-url');
        if (!addUrl) return;
        $.ajax({
            url: addUrl,
            type: 'post',
            dataType: 'json',
            data: { pid: pid },
            success: function (res) {
                if (res && res.error) {
                    createErrorNotification(res.msg || 'Error');
                    return;
                }
                toastUtil.displayToastPopup('.popine-success');
                currentSuggestions = currentSuggestions.filter(function (it) {
                    return !(it.productData && it.productData.product && it.productData.product.id === pid);
                });
                carousel.items = currentSuggestions;
            }
        });
    }

    /**
     * Handles the toggle favorite event from the carousel
     * @param {Event} e - The toggleFavorite event
     * @param {HTMLElement} carousel - The carousel element
     */
    function handleToggleFavorite(e, carousel) {
        const pid = e.detail && e.detail.productId;
        if (!pid) return;

        const item = currentSuggestions.filter(function (it) {
            return it.productData && it.productData.product && it.productData.product.id === pid;
        })[0];
        if (!item) return;

        const isFav = !!(item.productData.wishlist && item.productData.wishlist.isFavorite);
        if (isFav) {
            removeFromWishlist(pid, carousel);
        } else {
            addToWishlist(pid, carousel);
        }
    }

    element.addEventListener('replaceProduct', function (event) {
        const detail = event.detail;
        const card = getCartProductCard(element);
        if (!card || !card.lineItem) return;

        currentExchange = { detail: detail, card: card };

        document.getElementById('exchange-alert').isOpen = true;

        const summary = document.getElementById('exchange-summary');
        if (summary) summary.lineItem = card.lineItem;

        $.spinner().start();
        $.ajax({
            url: $('.cart-page').data('get-suggestions-url'),
            type: 'get',
            dataType: 'json',
            data: { pid: detail.pid },
            success: function (data) {
                document.getElementById('exchange-summary').lineItem = card.lineItem;
                document.getElementById('exchange-modal').isOpen = true;

                if (!data.items || data.items.length === 0) {
                    handleNoSuggestions();
                    $.spinner().stop();
                    return;
                }

                const noSuggestionsEl = document.getElementById('exchange-no-suggestions');
                if (noSuggestionsEl) noSuggestionsEl.style.display = 'none';
                document.getElementById('exchange-carousel').style.display = '';

                const carousel = document.getElementById('exchange-carousel');
                currentSuggestions = data.items;
                carousel.items = data.items;

                if (!carousel.dataset.actionBound) {
                    carousel.addEventListener('action', handleCarouselAction);
                    carousel.addEventListener('toggleFavorite', function (e) {
                        handleToggleFavorite(e, carousel);
                    });
                    carousel.dataset.actionBound = '1';
                }

                /**
                 * Déclenche Wizville dès que les conteneurs .wizville-stars sont rendus.
                 * fetchProductsRatingHtml scanne tout le document pour les .wizville-stars.
                 * @returns {boolean} determine if we display reviews or not
                 */
                function triggerWizville() {
                    if (carousel.querySelectorAll('.wizville-stars').length > 0) {
                        reviews.fetchProductsRatingHtml('list');
                        return true;
                    }
                    return false;
                }

                if (!triggerWizville()) {
                    const observer = new MutationObserver(function () {
                        if (triggerWizville()) {
                            observer.disconnect();
                        }
                    });
                    observer.observe(carousel, { childList: true, subtree: true });

                    setTimeout(function () {
                        observer.disconnect();
                        triggerWizville();
                    }, 2000);
                }
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
}

module.exports = function () {
    $(document).ready(function () {
        $('.error-message').hide();
        $('body').trigger('cart:init');
        stickyClubCardCTA();
        setClubCardSavings();
        getSetHeight();
        let basketMerge = document.querySelector('.basket-merge-message');
        if (basketMerge) {
            let message = basketMerge.dataset.message;
            let status = basketMerge.dataset.status || 'success';
            if (message) {
                notifUtils.send(message, status);
            }
            basketMerge.remove();
        }
        hydrateProductCards();
        hydrateExchangeModal();
        initUnavailableAlert();

        customElements.whenDefined('orch-cart-product-card').then(function () {
            document.querySelectorAll('orch-cart-product-card').forEach(function (el) {
                quantityChangeHandler(el);
                removeItemHandler(el);
                moveToWishlistHandler(el);
                editProductHandler(el);
                replaceProductHandler(el);
            });
        });
    });

    const exchangeModal = document.getElementById('exchange-modal');
    if (exchangeModal) {
        exchangeModal.addEventListener('closeModal', function () {
            this.isOpen = false;
        });
    }

    // eslint-disable-next-line no-unused-vars
    $('body').on('afterRemoveFromCart', function (e, data) {
        e.preventDefault();
    });

    $('body').on('click', '.minicart-prd-info .remove-product-btn', function (e) {
        e.preventDefault();
        var actionUrl = $(this).data('action');
        var productID = $(this).data('pid');
        var uuid = $(this).data('uuid');
        $('body').trigger('cart:removeProductLineItem', { pid: productID, action: actionUrl, uuid: uuid });
    });

    $('body').on('cart:removeProductLineItem', function (event, params) {
        var productID = params.pid;
        var url = params.action;
        var uuid = params.uuid;
        var urlParams = {
            pid: productID,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.basket.items.length === 0) {
                    $('.cart').empty().append('<div class="container cart-empty">'
                        + '<div class="row">'
                        + '    <div class="col-12 d-flex align-items-center flex-column">'
                        + '        <i class="icon icon-pictoToteBag"></i>'
                        + '        <span class=" text-muted">' + data.basket.resources.emptyCartMsg + '</span>'
                        + '    </div>'
                        + '</div>'
                        + '</div>');
                    $('.number-of-items').empty().append(data.basket.resources.numberOfItems);
                    $('.minicart-quantity').empty().append(data.basket.numItems);
                    $('.cart-total-quantity').empty().append(data.numItems);
                    $('.minicart-link').attr({
                        'aria-label': data.basket.resources.minicartCountOfItems,
                        title: data.basket.resources.minicartCountOfItems
                    });
                    $('.minicart .popover').empty().removeClass('show');
                    $('body').removeClass('modal-open');
                    $('html').removeClass('veiled');
                    $('.totals').addClass('emptycart-totals');
                } else {
                    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                            $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
                        }
                    }
                    $('.uuid-' + uuid).remove();
                    if (!data.basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }

                    handleClubCardUpdate(data.basket);
                    $('.coupons-and-promos').empty().append(data.basket.totals.discountsHtml);
                    updateCouponErrorMsg(data); // update the coupon error message when the user deletes a product from the cart
                    if (data.totalCartAmounts) {
                        data.basket.totalCartAmounts = data.totalCartAmounts;
                    }
                    updateCartTotals(data.basket);
                    setClubCardSavings();
                    updateApproachingDiscounts(data.basket.approachingDiscounts);
                    $('body').trigger('setShippingMethodSelection', data.basket);
                    validateBasket(data.basket);
                }

                $('body').trigger('cart:update', data);

                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('change', '.minicart-prd-info .quantity-form > .quantity', function () {
        var preSelectQty = $(this).data('pre-select-qty');
        var maxItemsNbCustPref = $('.cart-page-card__variations').data('maxnb-items') ? $('.cart-page-card__variations').data('maxnb-items') : 10;
        var quantity = $(this).val() <= maxItemsNbCustPref ? $(this).val() : maxItemsNbCustPref;
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var urlParams = {
            pid: productID,
            quantity: quantity,
            uuid: uuid,
            // eslint-disable-next-line no-undef
            pagetype: window.GTMConstants.ECOMM_PAGE_TYPE_CART
        };
        url = appendToUrl(url, urlParams);

        const totalProducts = $('.product-info').length;

        $(this).parents('.cart').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            context: this,
            dataType: 'json',
            success: function (data) {
                $('.quantity[data-uuid="' + uuid + '"]').val(quantity);
                $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                updateCouponErrorMsg(data); // update the coupon error message when the product quantity changes
                updateApproachingDiscounts(data.approachingDiscounts);
                updateCartTotals(data);
                setClubCardSavings();
                updateAvailability(data, uuid);
                validateBasket(data);
                $(this).data('pre-select-qty', quantity);

                $('body').trigger('cart:update', data);

                $('body').trigger('cart:afterUpdateQuantity', { response: data, totalProductsBeforeUpdate: totalProducts });

                $.spinner().stop();
                if ($(this).parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
                    // eslint-disable-next-line no-restricted-globals
                    location.reload();
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $(this).val(parseInt(preSelectQty, 10));
                    $.spinner().stop();
                }
            }
        });
    });

    // eslint-disable-next-line no-unused-vars
    $('body').on('afterRemoveFromCart', function (e, data) {
        e.preventDefault();
    });

    $('body').on('cart:afterUpdateQuantity', (e, data) => {
        const items = data.response.items.length;
        if (data.totalProductsBeforeUpdate !== items) {
            window.location.reload();
        }
    });

    $('body').on('product:afterAddToCart', (e, data) => {
        const cartContainer = document.getElementById('cart-container');
        if (cartContainer && data.cart && data.cart.cartProductCardJSON && data.cart.cartProductCardViewModel) {
            const productCards = data.cart.cartProductCardViewModel;

            productCards.forEach(function (pc) {
                let cardEl = document.querySelector('orch-cart-product-card[data-uuid="' + pc.lineItem.UUID + '"]');
                if (cardEl) {
                    cardEl.setAttribute('cartproductcard', JSON.stringify(pc));
                    cardEl.cartProductCard = pc;
                } else {
                    cardEl = document.createElement('orch-cart-product-card');
                    cardEl.className = 'o-d-block';
                    cardEl.setAttribute('data-uuid', pc.lineItem.UUID);
                    cardEl.setAttribute('cartproductcard', JSON.stringify(pc));
                    cartContainer.appendChild(cardEl);
                    customElements.whenDefined('orch-cart-product-card').then(function () {
                        cardEl.cartProductCard = pc;
                        quantityChangeHandler(cardEl);
                        removeItemHandler(cardEl);
                        moveToWishlistHandler(cardEl);
                        editProductHandler(cardEl);
                        replaceProductHandler(cardEl);
                    });
                }
            });

            cartContainer.setAttribute('data-cart', data.cart.cartProductCardJSON);

            $('.coupons-and-promos').empty().append(data.cart.totals.discountsHtml);
            updateCouponErrorMsg(data.cart);
            updateApproachingDiscounts(data.cart.approachingDiscounts);
            updateCartTotals(data.cart);
            validateBasket(data.cart);
            handleClubCardUpdate(data.cart);
            setClubCardSavings();
            handlePostCartAdd(data);
            updateAlmaGauge(data.cart.totalCartAmounts.totalToPay);
            updateShippingGauge(data.cart.totalCartAmounts.totalToPay);
            $('body').trigger('cart:update', data.cart);
        } else if ($('.cart-empty').length) {
            window.location.reload();
        }
    });
    // eslint-disable-next-line no-unused-vars
    $('body').on('afterRemoveFromCart', function (e, data) {
        e.preventDefault();
    });

    $('.optional-promo').click(function (e) {
        e.preventDefault();
        $('.promo-code-form').toggle();
    });

    // Open club card side modal on become-member-btn click
    $('body').on('click', 'button.become-member-btn', function (e) {
        e.preventDefault();
        $('#clubCardSideModal').modal('show');
    });

    $('body').on('click', 'button.add-club-to-cart-btn', function () {
        let $btn = $(this);
        let productID;
        let quantity = 1;
        let url;
        let uuid;

        // Check if button is inside the side modal
        if ($btn.closest('#clubCardSideModal').length > 0) {
            productID = $btn.data('pid');
            url = $btn.data('action');
        } else {
            // Original behavior for club-card-cta buttons
            let clubCardCtaContainer = $btn.parents('.club-card-cta');

            // if club-card-cta not found, that means we are in mobile view
            if (clubCardCtaContainer.length === 0) {
                clubCardCtaContainer = $btn.parents('.club-card-cta-sticky');
            }

            productID = clubCardCtaContainer.data('pid');
            quantity = clubCardCtaContainer.data('qty'); // 1
            url = clubCardCtaContainer.data('action');
            uuid = clubCardCtaContainer.data('uuid');
        }

        var form = {
            uuid: uuid,
            pid: productID,
            quantity: quantity
        };

        // Close modal if open
        $('#clubCardSideModal').modal('hide');

        $btn.parents('.cart').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'POST',
            context: this,
            data: form,
            dataType: 'json',
            success: function (data) {
                $.spinner().stop();
                if (data.hasClubCard) {
                    window.location.href = data.redirectUrl;
                }
                $('.coupons-and-promos').empty().append(data.cart.totals.discountsHtml);
                updateCartTotals(data.cart);

                updateApproachingDiscounts(data.cart.approachingDiscounts);
                updateProductDetails(data, uuid);
                data.cart.hasClubCardProduct = true;

                validateBasket(data.cart);

                handlePostCartAdd(data);
                $('body').trigger('cart:update', data.cart);

                handleClubCardUpdate(data.cart);
                setClubCardSavings();
                updateAlmaGauge(data.cart.totalCartAmounts.totalToPay);
                updateShippingGauge(data.cart.totalCartAmounts.totalToPay);

                if (data.cart.cartProductCardJSON) {
                    const productCard = JSON.parse(data.cart.cartProductCardJSON);
                    productCard.forEach(function (pc) {
                        const cardEl = document.querySelector(
                            'orch-cart-product-card[data-uuid="' + pc.lineItem.UUID + '"]'
                        );
                        if (cardEl) cardEl.cartProductCard = pc;
                    });
                }

                if ($('.cart-page').length > 0) {
                    // eslint-disable-next-line no-restricted-globals
                    location.reload();
                }
            },
            error: function (err) {
                $.spinner().stop();
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                }
                $.spinner().stop();
            }
        });
    });

    $('.shippingMethods').change(function () {
        var url = $(this).attr('data-actionUrl');
        var urlParams = {
            methodID: $(this).find(':selected').attr('data-shipping-id')
        };

        $('.totals').spinner().start();
        $('body').trigger('cart:beforeShippingMethodSelected');
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    updateCouponErrorMsg(data); // update the coupon error message when the shipping method updates
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                    updateAlmaGauge(data.totalCartAmounts.totalToPay);
                    updateShippingGauge(data.totalCartAmounts.totalToPay);
                }

                $('body').trigger('cart:shippingMethodSelected', data);
                $.spinner().stop();
            },
            error: function (err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('click', '.empty-promo-field', function () {
        $('.promo-code-form ').removeClass('is-invalid');
        $('.promo-code-form .form-control').removeClass('is-invalid');
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        $('.coupon-code-field').val('');
    });

    $('.promo-code-form').submit(function (e) {
        e.preventDefault();
        $.spinner().start();
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        if (!$('.coupon-code-field:visible').val()) {
            $('.promo-code-form .form-control').addClass('is-invalid').attr('aria-describedby', 'missingCouponCode');
            $('.coupon-missing-error').show();
            $.spinner().stop();
            return false;
        }
        var $form = $('.promo-code-form:visible');
        $('.promo-code-form .form-control').removeClass('is-invalid');
        $('.coupon-error-message').empty();
        $('body').trigger('promotion:beforeUpdate');

        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $('.promo-code-form ').addClass('is-invalid');
                    $('.promo-code-form .form-control').addClass('is-invalid').attr('aria-describedby', 'invalidCouponCode');
                    $('.coupon-error-message').empty().append(data.errorMessage);
                    $('body').trigger('promotion:error', data);
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    updateCouponErrorMsg(data); // update the coupon error message when submitting a coupon
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                    $('body').trigger('promotion:success', data);
                    $('.coupon-code-field').val('');
                    displayCouponAlert();
                    updateAlmaGauge(data.totalCartAmounts.totalToPay);
                    updateShippingGauge(data.totalCartAmounts.totalToPay);

                    if (data.cartProductCardJSON) {
                        const productCard = JSON.parse(data.cartProductCardJSON);
                        productCard.forEach(function (pc) {
                            const cardEl = document.querySelector(
                                'orch-cart-product-card[data-uuid="' + pc.lineItem.UUID + '"]'
                            );
                            if (cardEl) cardEl.cartProductCard = pc;
                        });
                    }
                }

                $.spinner().stop();
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });
        return false;
    });

    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var couponCode = $(this).data('code');
        var uuid = $(this).data('uuid');
        var $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
        var $productToRemoveSpan = $('.coupon-to-remove');

        $deleteConfirmBtn.data('uuid', uuid);
        $deleteConfirmBtn.data('code', couponCode);

        $productToRemoveSpan.empty().append(couponCode);
    });

    $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var couponCode = $(this).data('code');
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();
        $('body').trigger('promotion:beforeUpdate');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupon-uuid-' + uuid).remove();
                updateCartTotals(data);
                updateCouponErrorMsg(data); // update/empty the coupon error message when the user delete the coupon
                updateApproachingDiscounts(data.approachingDiscounts);
                validateBasket(data);
                updateAlmaGauge(data.totalCartAmounts.totalToPay);
                updateShippingGauge(data.totalCartAmounts.totalToPay);

                if (data.cartProductCardJSON) {
                    const productCard = JSON.parse(data.cartProductCardJSON);
                    productCard.forEach(function (pc) {
                        const cardEl = document.querySelector(
                            'orch-cart-product-card[data-uuid="' + pc.lineItem.UUID + '"]'
                        );
                        if (cardEl) cardEl.cartProductCard = pc;
                    });
                }

                $.spinner().stop();
                $('body').trigger('promotion:success', data);
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('click', '.cart-page .bonus-product-button', function () {
        $.spinner().start();
        $(this).addClass('launched-modal');
        $.ajax({
            url: $(this).data('url'),
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                base.methods.editBonusProducts(data);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
        $('#chooseBonusProductModal').remove();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');

        if ($('.cart-page').length) {
            $('.launched-modal .btn-outline-primary').trigger('focus');
            $('.launched-modal').removeClass('launched-modal');
        } else {
            $('.product-detail .add-to-cart').focus();
        }
    });

    $('body').on('click', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit, .minicart .product-edit .edit', function (e) {
        e.preventDefault();
        var editProductUrl = $(this).attr('href');
        getModalHtmlElement();
        fillModalElement(editProductUrl);
    });

    $('body').on('shown.bs.modal', '#editProductModal', function () {
        var editProductModal = $('#editProductModal');
        editProductModal.siblings().attr('aria-hidden', 'true');
        editProductModal.find('.close').focus();
    });

    $('body').on('hidden.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'false');
    });

    $('body').on('keydown', '#editProductModal', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#editProductModal',
            firstElementSelector: '.close',
            lastElementSelector: '.update-cart-product-global',
            nextToLastElementSelector: '.modal-footer .quantity-select'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $('body').on('product:updateAddToCart', function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        $('.update-cart-product-global', dialog).attr('disabled',
            !$('.global-availability', dialog).data('ready-to-order')
            || !$('.global-availability', dialog).data('available'));
    });

    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products
        $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available)
            .find('.availability-msg')
            .empty()
            .html(response.message);

        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('available'); });

            var allReady = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('ready-to-order'); });

            $('.global-availability', dialog)
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg', dialog).empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        } else {
            // single product
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);
        }
    });

    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.modal.show .product-quickview .bundle-items').length) {
            $('.modal.show').find(response.container).data('pid', response.data.product.id);
            $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
        } else {
            $('.modal.show .product-quickview').data('pid', response.data.product.id);
        }
    });

    $('body').on('change', '.quantity-select', function () {
        var selectedQuantity = $(this).val();
        $('.modal.show .update-cart-url').data('selected-quantity', selectedQuantity);
    });

    $('body').on('change', '.options-select', function () {
        var selectedOptionValueId = $(this).children('option:selected').data('value-id');
        $('.modal.show .update-cart-url').data('selected-option', selectedOptionValueId);
    });

    $('body').on('click', '.update-cart-product-global', function (e) {
        e.preventDefault();

        var updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
        var selectedQuantity = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
        var selectedOptionValueId = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-option');
        var uuid = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');

        var form = {
            uuid: uuid,
            pid: base.getPidValue($(this)),
            quantity: selectedQuantity,
            selectedOptionValueId: selectedOptionValueId
        };

        $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function (data) {
                    $('#editProductModal').modal('hide');

                    $('.coupons-and-promos').empty().append(data.cartModel.totals.discountsHtml);
                    updateCouponErrorMsg(data); // update the coupon error message when the product updates in the cart
                    updateCartTotals(data.cartModel);
                    setClubCardSavings();
                    updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                    updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);
                    updateAlmaGauge(data.cartModel.totalCartAmounts.totalToPay);
                    updateShippingGauge(data.cartModel.totalCartAmounts.totalToPay);

                    if (data.cartProductCardJSON) {
                        const productCard = JSON.parse(data.cartProductCardJSON);
                        const updatedCard = productCard.find(function (pc) {
                            return pc.lineItem.UUID === uuid;
                        });
                        if (updatedCard) {
                            const cardEl = document.querySelector(
                                'orch-cart-product-card[data-uuid="' + uuid + '"]'
                            );
                            if (cardEl) cardEl.cartProductCard = updatedCard;
                        }
                    }

                    if (data.uuidToBeDeleted) {
                        $('.uuid-' + data.uuidToBeDeleted).remove();

                        const delCard = document.querySelector(
                            'orch-cart-product-card[data-uuid="' + data.uuidToBeDeleted + '"]'
                        );
                        if (delCard) delCard.remove();
                    }

                    validateBasket(data.cartModel);

                    $('body').trigger('cart:update', data);

                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    $('body').on('cart:removeProductLineItem', function (event, params) {
        var productID = params.pid;
        var url = params.action;
        var uuid = params.uuid;
        var urlParams = {
            pid: productID,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.basket.items.length === 0) {
                    $('.cart').empty().append('<div class="container cart-empty">'
                        + '<div class="row">'
                        + '    <div class="col-12 d-flex align-items-center flex-column">'
                        + '        <i class="icon icon-pictoToteBag"></i>'
                        + '        <span class=" text-muted">' + data.basket.resources.emptyCartMsg + '</span>'
                        + '    </div>'
                        + '</div>'
                        + '</div>');
                    $('.number-of-items').empty().append(data.basket.resources.numberOfItems);
                    $('.minicart-quantity').empty().append(data.basket.numItems);
                    $('.cart-total-quantity').empty().append(data.numItems);
                    $('.minicart-link').attr({
                        'aria-label': data.basket.resources.minicartCountOfItems,
                        title: data.basket.resources.minicartCountOfItems
                    });
                    $('.minicart .popover').empty().removeClass('show');
                    $('body').removeClass('modal-open');
                    $('html').removeClass('veiled');
                    $('.js-cart-mobile-totals').remove();
                } else {
                    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                            $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
                        }
                    }
                    $('.uuid-' + uuid).remove();
                    if (!data.basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }

                    handleClubCardUpdate(data.basket);
                    $('.coupons-and-promos').empty().append(data.basket.totals.discountsHtml);
                    updateCouponErrorMsg(data); // update the coupon error message when the user deletes a product from the cart
                    if (data.totalCartAmounts) {
                        data.basket.totalCartAmounts = data.totalCartAmounts;
                    }
                    updateCartTotals(data.basket);
                    setClubCardSavings();
                    updateApproachingDiscounts(data.basket.approachingDiscounts);
                    $('body').trigger('setShippingMethodSelection', data.basket);
                    validateBasket(data.basket);
                }

                $('body').trigger('cart:update', data);

                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    /**
     * move items from Cart to wishlist
     * returns json object with success or error message
     */
    $('body').on('click', '.line-item-overlay .move', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var pid = $(this).data('pid');
        var uuid = $(this).data('uuid');
        var action = $(this).data('action');
        var optionId = $(this).closest('.product-info').find('.lineItem-options-values').data('option-id');
        var optionVal = $(this).closest('.product-info').find('.lineItem-options-values').data('value-id');
        optionId = optionId || null;
        optionVal = optionVal || null;
        if (!url || !pid) {
            return;
        }

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                pid: pid,
                optionId: optionId,
                optionVal: optionVal
            },
            success: function (data) {
                pushToDataLayer(data.gtmData);
                $('body').trigger('cart:removeProductLineItem', { pid: pid, action: action, uuid: uuid });
                toastUtil.displayToastPopup('.popine-success');
            },
            // eslint-disable-next-line no-unused-vars
            error: function (err) {

            }
        });
    });

    $('body').on('click', '.promo-code .card .card-header button', function () {
        var ariaControls = $(this).attr('aria-controls');
        var ariaExpanded = $(this).attr('aria-expanded');
        $(ariaControls).toggle();
        $(this).attr('aria-expanded', !JSON.parse(ariaExpanded));
    });

    base.selectAttribute();
    base.colorAttribute();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();

    // product recommendation carousel init
    const recommendationUtils = require('../components/recommendations');
    recommendationUtils.initRecommandationLogic();
    recommendationUtils.initProductRecommendationSlick();

    $('body').on('editproductmodal:ready', function () {
        $('.alert-incompatible-shipping-methods').html($('#incompatible-shipping-methods-message-holder').html());
        const $carousel = $('.quick-view-carousel-area .detail-slider-nav.detail-desktop-images.quickview-carousel').not('.slick-initialized');
        $carousel.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            focusOnSelect: true,
            infinite: false,
            arrows: true
        });
    });

    $('.checkout-navbar-back button').click(function (e) {
        e.preventDefault();

        var encodedUrl = $(this).attr('data-cbo');
        var backButtonUrl = decodeURIComponent(window.atob(encodedUrl));
        window.location.href = backButtonUrl;
    });
};

$(document).on('click', '.product-attributes-section .attribute.toggle', attributesLogic.toggleAttribute);
$(document).on('click', '.attribute-values .circle-unselected', attributesLogic.selectAttributeValue);
